<template>
<div>
    <ValidationObserver ref="observer"
        v-slot="{ passes }">
        <h1 class="title">Ordenes de Compra o Servicio</h1>
        <hr />
        <div v-if="orden.estado.es_editable">
            <orden-header :orden="orden"></orden-header>
            <br />
            <orden-detail :orden="orden"
                :passes="passes"></orden-detail>
        </div>
        <div v-else>
            No tiene los permisos para editar esta orden
        </div>
    </ValidationObserver>
</div>
</template>

<script>
import { ValidationObserver } from "vee-validate"
import OrdenHeader from "./OrdenHeader"
import OrdenDetail from "./OrdenDetail"
import axios from "axios"
import moment from 'moment'

export default {
    name: "OrdenEdit",
    components: {
        OrdenHeader,
        OrdenDetail,
        ValidationObserver
    },
    data() {
        return {
            orden: {
                orden_items: [],
                orden_impuestos: [
                    {
                        id_orden_impuesto: null,
                        descripcion: "IGV",
                        valor: 0.18,
                        valor_aplicado: 0,
                        ori_tipo: 1
                    },
                    {
                        id_orden_impuesto: null,
                        descripcion: "Percepción",
                        valor: 0,
                        valor_aplicado: 0,
                        ori_tipo: 3
                    }
                ],
                descuento: 0,
                tipo_descuento: 1,
                tipo_orden: 1,
                lugar_entrega: "AV. MANUEL OLGUÍN 211, SANTIAGO DE SURCO",
                monto_con_impuesto: 0,
                monto_son_impuesto: 0,
                es_importacion: false,
                centro_costo: {
                    id_centro_costo: null
                },
                proveedor: {
                    id_proveedor: null
                },
                metodo_pago: {
                    id_metodo: null
                },
                tipo_documento: {
                    id_tipo_documento: null
                },
                estado: { es_editable: true },
                fecha_pago: new Date(),
                carta_credito: "",
                condicion_comercial: { id_condicion: null },
                gerencia: { id_usuario: null },
                administrador: { id_usuario: null },
                contabilidad: { id_usuario: null },
                pais: { id_pais: null },
                moneda: { id_moneda: null },
                referencia: "",
                referencia_detalle: "",
                observacion: "",
                is_new: false
            }
        }
    },
    methods: {
        loadData() {
            axios
                .post(
                    "/orden/get-orden-detail",
                    {},
                    { headers: { idOrden: this.$route.params.id } }
                )
                .then(
                    resp => {
                        let orden = resp.data
                        orden.fecha_pago = moment(orden.fecha_pago).toDate()
                        this.orden = orden
                    },
                    () => { }
                )
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>

<style scoped></style>
